"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkContainer = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".c04703694{position:relative}.c04703694 a{text-decoration:none}.c04703694 a:link{color:var(--color-flomni-blue-70)}.c04703694 a:visited{color:var(--color-flomni-blue-70)}.c04703694 a:hover{opacity:.7}.c04703694 a:active{opacity:.5}.cf859e755{opacity:.4}.cf859e755 a{cursor:default}.cf859e755 a:hover{opacity:1}.cf859e755 a:active{opacity:1}.c52947266{font-size:1rem;font-weight:400;line-height:1.125rem}.cac9510aa{font-size:.75rem;font-weight:400;line-height:.8125rem}.cb222ef6e{font-size:.875rem;font-weight:500;line-height:1rem}.c313ea7b5 a{position:relative}.c313ea7b5 a svg{position:absolute;width:auto;top:0;bottom:0;margin:auto}.c2818544e svg{height:100%}.c575f59eb svg{height:68%}.cdeb943b0 svg{left:0}.cddec06f6 svg{right:0}.cdeb943b0.c2818544e a{padding-left:1.5em}.cdeb943b0.c575f59eb a{padding-left:1em}.cddec06f6.c2818544e a{padding-right:1.5em}.cddec06f6.c575f59eb a{padding-right:1em}");
var styles = {
  root: 'c04703694',
  '--disabled': 'cf859e755',
  '--size-usual': 'c52947266',
  '--size-small': 'cac9510aa',
  '--size-middle': 'cb222ef6e',
  '--has-icon': 'c313ea7b5',
  '--icon-size-usual': 'c2818544e',
  '--icon-size-small': 'c575f59eb',
  '--icon-position-left': 'cdeb943b0',
  '--icon-position-right': 'cddec06f6'
};

var LinkContainer = function LinkContainer(props) {
  var children = props.children,
      size = props.size,
      iconPosition = props.iconPosition,
      hasIcon = props.hasIcon,
      iconSize = props.iconSize,
      classes = props.classes,
      disabled = props.disabled,
      clickPreventDefault = props.clickPreventDefault;
  var cn = (0, _useStyles.useStyles)(styles, classes);

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      node = _useState2[0],
      setNode = _useState2[1];

  var elRef = (0, _react.useCallback)(function (node) {
    return setNode(node);
  }, []);
  (0, _react.useEffect)(function () {
    if (!node) return;
    if (!clickPreventDefault) return;
    var collection = node.getElementsByTagName('a');
    var hrefs = new Array(collection.length).fill(null).map(function (item, index) {
      return collection[index];
    });

    var handler = function handler(event) {
      return event.preventDefault();
    };

    hrefs.forEach(function (href) {
      return href.addEventListener('click', handler);
    });
    return function () {
      return hrefs.forEach(function (href) {
        return href.removeEventListener('click', handler);
      });
    };
  }, [clickPreventDefault, node]);
  return /*#__PURE__*/_react.default.createElement("span", {
    ref: elRef,
    className: (0, _classnames.default)(cn.root, cn.size[size], (0, _defineProperty2.default)({}, cn.has.icon, hasIcon), (0, _defineProperty2.default)({}, cn.icon.position[iconPosition], hasIcon), (0, _defineProperty2.default)({}, cn.icon.size[iconSize], hasIcon), (0, _defineProperty2.default)({}, cn.disabled, disabled))
  }, children);
};

exports.LinkContainer = LinkContainer;
var size = ['small', 'usual', 'middle'];
var iconPosition = ['right', 'left'];
var iconSize = ['small', 'usual'];
LinkContainer.modes = {
  size: size,
  iconPosition: iconPosition,
  iconSize: iconSize
};
LinkContainer.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,

  /* styling modificators */
  size: (0, _propTypes.oneOf)(size),
  hasIcon: _propTypes.bool,
  iconPosition: (0, _propTypes.oneOf)(iconPosition),
  iconSize: (0, _propTypes.oneOf)(iconSize),
  disabled: _propTypes.bool,
  clickPreventDefault: _propTypes.bool,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
LinkContainer.defaultProps = {
  size: 'usual',
  hasIcon: false,
  disabled: false,
  clickPreventDefault: false,
  iconPosition: 'left',
  iconSize: 'usual',
  classes: {}
};